<div class="dialog-content-wrapper confirm">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Confirmar</span>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                    <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePrefectScrollbar>
        {{confirmMessage}}
    </div>
    <div mat-dialog-actions class="m-0 p-16 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">Confirmar</button>
        <button mat-button (click)="dialogRef.close(false)">Cancelar</button>
    </div>
</div>
